import type { CustomerRole } from "../types/thalamos.js";
import { personActionsFromInvolvementKindInRole } from "./personActionsFromInvolvementKindInRole.js";

/**
 * Whether a user acting in a role can have assessments waiting for their
 * decision: whether an approver's involvement conveys `approve` in it.
 */
export const isRoleAbleToApprove = (role: CustomerRole | null): boolean =>
  personActionsFromInvolvementKindInRole("approver", role).includes("approve");
